import { Star, StarHalf } from "lucide-react"

interface ReviewStarsProps {
  rating: number
  size?: "sm" | "md" | "lg"
}

export function ReviewStars({ rating, size = "md" }: ReviewStarsProps) {
  const sizeClasses = {
    sm: "h-3 w-3",
    md: "h-4 w-4",
    lg: "h-5 w-5"
  }

  const stars = []
  const fullStars = Math.floor(rating)
  const hasHalfStar = rating % 1 >= 0.5

  // Add full stars
  for (let i = 0; i < fullStars; i++) {
    stars.push(
      <Star 
        key={`full-${i}`} 
        className={`${sizeClasses[size]} fill-yellow-400 text-yellow-400`} 
      />
    )
  }

  // Add half star if needed
  if (hasHalfStar) {
    stars.push(
      <StarHalf 
        key="half" 
        className={`${sizeClasses[size]} fill-yellow-400 text-yellow-400`} 
      />
    )
  }

  // Add empty stars
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0)
  for (let i = 0; i < emptyStars; i++) {
    stars.push(
      <Star 
        key={`empty-${i}`} 
        className={`${sizeClasses[size]} text-gray-300`} 
      />
    )
  }

  return <div className="flex">{stars}</div>
} 